import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import InfiniteScroll from "react-infinite-scroller";

import { formatMoney } from "../../../../helpers/formatters";

import DefaultImg from "../../../../assets/images/no_image.png";

import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const propTypes = {
  services: PropTypes.array,
  loadMore: PropTypes.func,
  totalPage: PropTypes.number,
  totalPageOnRequest: PropTypes.number,
  currentPage: PropTypes.number,
  currentPageOnRequest: PropTypes.number,
  state: PropTypes.string,
  wishlists: PropTypes.array,
  addWishlist: PropTypes.func,
  removeWishlist: PropTypes.func,
  category: PropTypes.any,
  wishlistInjection: PropTypes.func,
};

const Items = ({
  services,
  loadMore,
  totalPage,
  currentPage,
  wishlists,
  addWishlist,
  removeWishlist,
  category,
  wishlistInjection,
}) => {
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState("jp");
  const navigate = useNavigate();

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language]);

  const goToDetail = (id) => {
    navigate(`/product?id=${category === "3" ? "shopping-" : ""}${id}`);
  };

  const checkWishlist = (item) => {
    const check = wishlists && wishlists.find((wish) => wish.Id === item.Id);

    return check;
  };
  return (
    <Row>
      <Col
        xs={12}
        lg={category && category !== "3" ? 7 : 12}
        className="leftSection"
      >
        {services && services.length > 0 ? (
          <InfiniteScroll
            loadMore={loadMore}
            hasMore={totalPage > 1 && totalPage > currentPage}
          >
            <Row>
              {services.map((service, i) => {
                return (
                  <Col
                    xs={12}
                    lg={category && category !== "3" ? 6 : 3}
                    key={i}
                  >
                    <div className="item">
                      <div
                        className="image"
                        onClick={(e) => {
                          e.preventDefault();
                          goToDetail(service.Id, category);
                        }}
                      >
                        <img
                          src={
                            service.Images !== null
                              ? service.Images[0].Url
                              : DefaultImg
                          }
                          alt={service.Name}
                        />
                      </div>
                      <div className="info">
                        <a href="#">
                          <h6
                            className="title"
                            onClick={(e) => {
                              e.preventDefault();
                              goToDetail(service.Id, category);
                            }}
                          >
                            {service.Name}
                          </h6>
                        </a>

                        <div className="address">
                          〒{service.PhysicalAddress.PostCode}
                          {service.PhysicalAddress.State
                            ? `${service.PhysicalAddress.State}`
                            : ""}
                          {service.PhysicalAddress.City
                            ? `${service.PhysicalAddress.City}`
                            : ""}
                          {service.PhysicalAddress.Line2
                            ? `${service.PhysicalAddress.Line2}`
                            : ""}
                          {service.PhysicalAddress.Line1
                            ? `${service.PhysicalAddress.Line1}`
                            : ""}
                        </div>
                        <div className="price">
                          {service.Availability.Calendar.LowestRate &&
                            (lang === "jp"
                              ? `¥${formatMoney(
                                  service.Availability.Calendar.LowestRate
                                )} から`
                              : `From ¥${formatMoney(
                                  service.Availability.Calendar.LowestRate
                                )}`)}
                        </div>
                        <div
                          className="desc"
                          dangerouslySetInnerHTML={{
                            __html: service.LongDescription,
                          }}
                        ></div>
                      </div>
                      <div className="buttonWrapper m-0">
                        {category && category !== "3" && (
                          <Button
                            className="w-100 mb-2"
                            variant="primary"
                            onClick={() =>
                              checkWishlist(service)
                                ? removeWishlist(service)
                                : addWishlist(service)
                            }
                          >
                            {checkWishlist(service)
                              ? t("remove_wishlist")
                              : t("add_to_reservation")}
                          </Button>
                        )}
                        <Button
                          className="w-100"
                          variant="secondary"
                          onClick={() => goToDetail(service.Id, category)}
                        >
                          {t("view_details")}
                        </Button>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </InfiniteScroll>
        ) : (
          <h3 className="text-center mt-3">{t("not_found")}</h3>
        )}
      </Col>
      {category && category !== "3" && (
        <div className="col-12 col-lg-5 rightSection">
          <div className="wishlistWrapper">
            <div className="wishlistTitle">{t("wishlists")}</div>
            <div className="wishlistItems">
              {wishlists && wishlists.length > 0 ? (
                wishlists.map((wishlist, i) => {
                  return (
                    <div className="itemWishlist item" key={i}>
                      <div className="imageContainer">
                        <div
                          className="image"
                          onClick={(e) => {
                            e.preventDefault();
                            goToDetail(wishlist.Id, category);
                          }}
                        >
                          <img
                            src={
                              wishlist.Images && wishlist.Images.length > 0
                                ? wishlist.Images[0].Url
                                : DefaultImg
                            }
                            alt={wishlist.Name}
                          />
                        </div>
                      </div>
                      <div className="info">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            goToDetail(wishlist.Id, category);
                          }}
                        >
                          <h6 className="title">{wishlist.Name}</h6>
                        </a>
                        <div className="price">
                          {wishlist &&
                            wishlist.Availability?.Calendar?.LowestRate &&
                            (lang === "jp"
                              ? `¥${formatMoney(
                                  wishlist.Availability.Calendar.LowestRate
                                )} から`
                              : `From ¥${formatMoney(
                                  wishlist.Availability.Calendar.LowestRate
                                )}`)}
                        </div>
                        <div
                          className="desc"
                          dangerouslySetInnerHTML={{
                            __html: wishlist.LongDescription,
                          }}
                        ></div>
                      </div>
                      <div>
                        <div
                          className="removeWishlist"
                          onClick={() => removeWishlist(wishlist)}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="wishlistEmpty">{t("wishlist_empty")}</div>
              )}
            </div>
            <div className="wishlistButton">
              {!isEmpty(wishlists) && (
                <Button
                  className="w-100 mb-2"
                  variant="primary"
                  onClick={() => wishlistInjection()}
                >
                  {t("check_availability")}{" "}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* <div className="loadMore mb-3">
        {totalPage > 1 && totalPage > currentPage && state === "quick" && (
          <Button
            variant="primary"
            className=" py-2"
            onClick={() => loadMore()}
          >
            {t("load_more")}
          </Button>
        )}
      </div> */}
      {/* <div className="loadMoreRequest mb-3">
        {totalPageOnRequest > 1 &&
          totalPageOnRequest > currentPageOnRequest &&
          state === "request" && (
            <Button
              variant="primary"
              className="py-2"
              onClick={() => loadMore()}
            >
              {t("load_more")}
            </Button>
          )}
      </div> */}
    </Row>
  );
};

Items.propTypes = propTypes;

export default Items;
